import "core-js/modules/es.array.push.js";
export default {
  data: function data() {
    return {
      serverId: "",
      channel_value: "",
      tableData: [{
        serverId: 111,
        roleName: "小明",
        roleId: 11
      }, {
        serverId: 111,
        roleName: "小红",
        roleId: 2
      }]
    };
  },
  methods: {
    openBox: function openBox() {
      this.$notify({
        title: "聊天监控",
        message: "（1）可勾选聊天监控频道，默认全部频道。" + "(2) 可勾选监控的服务器列表，默认取最新开的5个服务器。" + "(3)前后端使用websocket链接，后端根据聊天日志，根据前端上次获取和推送的聊天日志，推送勾选的服务器最新聊天信息给客户端" + "(4)可点击玩家角色名称操作禁言、封禁等操作。",
        duration: 0
      });
    },
    //获取到这一行的roleID然后跳转到  玩家禁言
    goChatRouterMsg: function goChatRouterMsg(e) {
      this.$router.push({
        name: "chatBanned",
        query: {
          roleId: e
        }
      });
    },
    //获取到这一行的roleID然后跳转到  玩家封禁
    goUserRouterMsg: function goUserRouterMsg(e) {
      this.$router.push({
        name: "userBanned",
        query: {
          roleId: e
        }
      });
    }
  }
};